import { useDispatch } from 'react-redux';
import { FlexContainer, Text, Buttons, Notification } from '@taxdown/piccolo-web';
import { locizeNS } from 'Services/i18n';
import { history } from 'Store';
import { hideModalAction } from 'Store/modules/app/actions';
import { useTranslation } from 'Hooks/useTranslation';
import { useFetchPreviousYearIsRequest } from 'Containers/Dashboard/hooks';
import { routesByPreviousYearStage } from 'Containers/Dashboard/components/PreviousYearBanner/utils';
import { PreviousYearStatus } from 'Containers/PreviousYears/types';
import { CloseIcon } from 'Components/icons';
import { removeOverflow } from 'Styles/utils/utils';
import { routes } from 'Constants/routes';
import * as Styled from './styles';
import { useGetUserSatData } from './hooks';

const TaxSeasonOver = (): JSX.Element => {
  const dispatch = useDispatch();
  const { t } = useTranslation(locizeNS.MODALS);
  const { data: isRequest, isLoading } = useFetchPreviousYearIsRequest();
  const data = useGetUserSatData();

  const handleCloseModal = (): void => {
    removeOverflow();
    dispatch(hideModalAction());
  };

  const handleOnClickPreviousYear = (): void => {
    if (isRequest && data && data.stage) {
      const route =
        data.stage === PreviousYearStatus.CALCULATING
          ? routes.PREVIOUS_YEARS_CALCULATING_LOADER
          : routesByPreviousYearStage[data?.stage];
      history.push(route, {
        products: {
          isPreviousYear: true,
        },
      });
    } else if (isRequest && !data) {
      history.push(routes.DATAGATHERING_LOADER, {
        products: {
          isPreviousYear: true,
        },
      });
    } else {
      history.push(routes.PREVIOUS_YEARS_INFO);
    }
    handleCloseModal();
  };
  return (
    <Styled.ModalContainer align="center" justify="center">
      <Styled.ModalContent direction="column">
        <Styled.Container direction="column" gap="dimension_16">
          <FlexContainer align="flex-end" justify="flex-end">
            <Styled.CloseButton onClick={handleCloseModal}>
              <CloseIcon />
            </Styled.CloseButton>
          </FlexContainer>
          <Text type="fds_heading_bold_H5" size="fds_size_32" align="center">
            {t('TaxSeason.Over.Title')}
          </Text>
          <Notification
            hasIcon
            id="warning"
            mode="warning"
            title={t('TaxSeason.Over.banner.title')}
            noClose
            description={t('TaxSeason.Over.Banner')}
          />
          <Buttons.Classic
            onClick={handleOnClickPreviousYear}
            label={t('TaxSeasonOver.previous.year')}
            mode="success"
            size="m"
            disabled={isLoading}
          />
        </Styled.Container>
      </Styled.ModalContent>
    </Styled.ModalContainer>
  );
};

export default TaxSeasonOver;
